<script setup>
import { useI18n } from 'vue-i18n'
import {formatToLocalTime} from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()
const ipTime=userStore.ipTime;
const { t } = useI18n();
const props = defineProps(["details"])
const from = props.details
const fomartState = (state) => {
    const stateMap = {
        1: t('number31'),
        2: t('number32'),
        3: t('number38'),
        4:t('number34')
    }
    return stateMap[state]
}
</script>
<template>
    <div class="orderDetails">
        <!-- <div class="title">钱包订单详情</div> -->
        <div class="sn">
            <div class="pc">{{ $t('number45') }}:{{ from.order_no }}</div>
            <div class="phone">{{ $t('number59') }}:{{ from.order_no }}</div>
            <div class="pc">{{ $t('number66') }}: {{formatToLocalTime(ipTime, from.created_at)}}</div>
        </div>
        <div class="pc">
            <div class="content">
                <div class="item">
                
                    <div>{{$t('number104')}}:{{ from.bank_name }}</div>
                    <div>{{$t('number105')}}:{{ from.order_credit }}</div>
                </div>
                <div class="item">
                    <div>{{$t('number106')}}:{{ fomartState(from.status)}}</div>
                    <div v-if="from.statu==4">{{$t('number107')}}:{{formatToLocalTime(ipTime, from.pay_time)}}</div>
                </div>
            </div>
        </div>
        <div class="phone">
            <div class="content">
                <div class="item">
                    <div>{{ $t('number66') }}:</div>
                    <div>{{formatToLocalTime(ipTime, from.created_at)}}</div>
                </div>
                <div class="item">
                
                    <div>{{$t('number104')}}:</div>
                   <div>{{ from.bank_name }}</div>
                </div>
                <div class="item">
                    <div>{{$t('number105')}}:</div>
                    <div>{{ from.order_credit }}</div>
                </div>
                <div class="item">
                    <div>{{$t('number106')}}:</div>
                    <div>{{ fomartState(from.status)}}</div>
                    
                </div>
                <div class="item" v-if="from.statu==4">
                    <div>{{$t('number107')}}:</div>
                    <div>{{formatToLocalTime(ipTime, from.pay_time)}}</div>
                </div>
            </div>
        </div>


    </div>

</template>
<style scoped lang="scss">
.pc {
    display: block;
}

.phone {
    display: none;
}

.orderDetails {
    .title {
        font-weight: 500;
        font-size: 20px;
        color: #20253A;
        line-height: 20px;
        text-align: left;
        font-style: normal;
    }

    .sn {
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        font-size: 15px;
        color: #20253A;
        padding: 0 0 20px 0;
    }

    .content {
        padding: 10px;

        background: #FFFFFF;
        box-shadow: -2px 0px 10px 0px rgba(43, 45, 55, 0.02), 2px 0px 10px 0px rgba(43, 45, 55, 0.02);
        border-radius: 5px;
        border: 1px solid #EFF0F2;

        .item {
            padding: 15px;
            display: flex;
            justify-content: space-between;
        }
    }
}

@media (max-width: 768px) {
    .pc {
        display: none !important;
    }

    .phone {
        display: block;
    }

    .orderDetails {
        .sn {
            display: flex;
            flex-direction: column;
        }

        .content {
            padding: 0;
            border: none;
            box-shadow:none;
            border-top: 1px solid #eee;
            padding-top: 15px;
            .item{
                padding:10px 0;
                >div:last-child{
                    color: #888888;
                }
            }
        }
    }
}
</style>